import { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { trackPurchase, popCheckoutValue } from '@/services/analytics';

export const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current || !sessionId) return;
    tracked.current = true;
    // We use session_id as transaction_id.  Actual order value is in Stripe;
    // server-side purchase tracking (via webhook) is more reliable for revenue,
    // but this captures the frontend conversion moment for funnel analysis.
    const track = async () => {
      const value = await popCheckoutValue();
      trackPurchase({ transaction_id: sessionId, value });
    };
    track();
  }, [sessionId]);

  return (
    <div
      className="container-main"
      style={{
        maxWidth: '640px',
        paddingTop: 'var(--space-16)',
        paddingBottom: 'var(--space-16)',
      }}
    >
      <div
        className="text-center"
        style={{
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border-default)',
          backgroundColor: 'var(--bg-surface)',
          padding: 'var(--space-6)',
        }}
      >
        <div
          style={{
            width: '64px',
            height: '64px',
            borderRadius: 'var(--radius-full)',
            backgroundColor: 'var(--color-success-50)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto var(--space-6)',
          }}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--color-success-600)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1
          style={{
            fontSize: 'var(--text-2xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            letterSpacing: 'var(--tracking-tight)',
          }}
        >
          Order Confirmed
        </h1>
        <p
          style={{
            marginTop: 'var(--space-2)',
            color: 'var(--text-tertiary)',
            maxWidth: '400px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          Your payment was successful. We'll start processing your order right away.
          You'll receive a confirmation email shortly.
        </p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-3)',
            marginTop: 'var(--space-8)',
            maxWidth: '280px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Link to="/orders">
            <Button style={{ width: '100%' }}>View My Orders</Button>
          </Link>
          <Link to="/">
            <Button
              variant="secondary"
              style={{ width: '100%' }}
            >
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
